import React from 'react';
import '../styles/LineHeader.css';

export default (props) => {
  const { children } = props;
  return <div className="line-header">{children}</div>;
};
